var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.33 22.622l-6.365 6.364a3 3 0 01-4.242-4.243l6.363-6.364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.207a5 5 0 008.192-5.362l-2.535 2.534-2.828-2.829 2.534-2.534a5.001 5.001 0 00-5.362 8.191z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgProduction;